import { render } from "./detail.vue?vue&type=template&id=62a48a14&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=62a48a14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62a48a14"

export default script